import { PayloadAction, ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IClone } from "src/@types/clones";
import { getCurrentCloneAsync } from "./actions";
import { CurrentCloneState } from "./slice";

type ActionReducerMapBuilderWitCurrentCloneState =
  ActionReducerMapBuilder<CurrentCloneState>;

export const getCurrentCloneReducer = (
  builder: ActionReducerMapBuilderWitCurrentCloneState
) => {
  builder.addCase(getCurrentCloneAsync.pending, (state) => {
    state.isLoading = true;
    state.item = null;
  });

  builder.addCase(
    getCurrentCloneAsync.fulfilled,
    (state, actions: PayloadAction<IClone>) => {
      state.isLoading = false;
      state.item = actions.payload;
    }
  );

  builder.addCase(getCurrentCloneAsync.rejected, (state) => {
    state.isLoading = false;
    state.item = null;
  });
};
